import { render, staticRenderFns } from "./EventsFrenteModal.vue?vue&type=template&id=a2a14ad4"
import script from "./EventsFrenteModal.vue?vue&type=script&lang=js"
export * from "./EventsFrenteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports